"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("webapp-genric/dist/super-table/model/table/types");
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const StatusIndicator_1 = require("../../styled/StatusIndicator");
exports.Pagination = ({ meta, handler, pageList }) => {
    const { totalCount = 50, page = 1, pageSize = 25, pointer: { next, current, prev }, } = meta;
    const isNext = Boolean(next);
    const isPrev = Boolean(prev);
    const onPagination = (n = false) => {
        const direction = n ? types_1.Direction.FORWARD : types_1.Direction.BACKWARD;
        const token = n ? next : prev;
        handler && handler(pageSize, direction, token);
    };
    const onPageSizeChange = (ps) => {
        handler && handler(ps, types_1.Direction.FORWARD);
    };
    const _pageList = pageList === null || pageList === void 0 ? void 0 : pageList.map((p) => ({ label: p.toString(), value: p }));
    const defaultValue = {
        label: pageSize.toString(),
        value: pageSize.toString(),
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StatusIndicator_1.StyledCustomDropDown, { name: "super-table-pageSize-control", onChange: onPageSizeChange, title: `Size per page ${pageSize}`, value: defaultValue, className: "px-2", options: _pageList || [defaultValue] }),
        react_1.default.createElement(reactstrap_1.ButtonGroup, { size: "sm", className: "d-flex align-items-center ml-2" },
            react_1.default.createElement(reactstrap_1.Button, { size: "sm", className: "", disabled: !isPrev, color: "light", onClick: () => onPagination() },
                react_1.default.createElement("i", { className: "fa fa-arrow-left" })),
            react_1.default.createElement(reactstrap_1.Button, { size: "sm", className: "", disabled: !isNext, color: "light", onClick: () => onPagination(true) },
                react_1.default.createElement("i", { className: "fa fa-arrow-right" })))));
};
//# sourceMappingURL=Pagination.js.map